import { ChangeEvent, useEffect, useState } from 'react'
import { IOrder } from '../../../../../app/entities/Order'
import styles from '../styles.module.css'
import {
  ARRIVED_STATUSES,
  CANCELLED_STATUSES,
  STATUSES,
} from '../../../global/constants/order-status'
import moment from 'moment'
import determineHalvedTimeSlot from '../../../global/utils/determine-halved-time-slot'
import { useNavigate } from 'react-router-dom'
import PrimaryCheckbox from '../../../global/components/checkbox/Checkbox'
import { UNIVERSAL_BRAND_NAME } from '../../../global/constants/customer-vehicle'

interface OrderInformationProps {
  order: IOrder | null
  isStandbyQueueChecked: boolean
  standbyQueueHandler: (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void
  isDelivery: boolean
}

export default function OrderInformation(props: OrderInformationProps) {
  const navigate = useNavigate()

  const { order, isStandbyQueueChecked, standbyQueueHandler, isDelivery } =
    props
  const [customerName, setCustomerName] = useState('')
  const [timeSlotInformation, setTimeSlotInformation] = useState('')
  const [vehicleYearAndMake, setVehicleYearAndMake] = useState('')
  const [vehicleModelAndVariant, setVehicleModelAndVariant] = useState('')
  const [disableStandbyQueueOption, setDisableStandbyQueueOption] =
    useState(false)

  useEffect(() => {
    const orderVehicle = order?.orderVehicles[0]
    const vehicleYear = orderVehicle?.customerVehicle?.year
    const vehicleMake = orderVehicle?.customerVehicle?.brand?.name
    const vehicleModel = orderVehicle?.customerVehicle?.model
    const vehicleVariant = orderVehicle?.customerVehicle?.variant

    const timeSlot = order?.timeSlot
    const timeSlotFromMoment = moment.utc(timeSlot?.fromTime)
    const timeSlotToMoment = moment.utc(timeSlot?.toTime)

    const routeInstruction = order?.routeInstructions[0]

    const { fromTimeMoment, toTimeMoment } = determineHalvedTimeSlot(
      timeSlot,
      routeInstruction,
      isDelivery,
    )

    const timeSlotInformationStr =
      fromTimeMoment && toTimeMoment
        ? `${fromTimeMoment.format(
            'M/D/YY, [arriving] h:mma',
          )} - ${toTimeMoment.format('h:mma')}`
        : `${timeSlotFromMoment.format(
            'M/D/YY, [arriving] h:mma',
          )} - ${timeSlotToMoment.format('h:mma')}`

    const shouldDisableStandbyQueueOption = [
      ...CANCELLED_STATUSES,
      order?.status === STATUSES.completed,
    ].includes(order?.status ?? '')

    const isUniversalVehicle = vehicleMake === UNIVERSAL_BRAND_NAME

    setCustomerName(order?.customer?.fullName ?? '')
    setTimeSlotInformation(timeSlotInformationStr)
    setVehicleYearAndMake(
      isUniversalVehicle ? '' : `${vehicleYear} ${vehicleMake}`,
    )
    setVehicleModelAndVariant(
      isUniversalVehicle ? '' : `${vehicleModel} ${vehicleVariant}`,
    )
    setDisableStandbyQueueOption(shouldDisableStandbyQueueOption)
  }, [order, isDelivery])

  function onRescheduleClick() {
    const url = `/reschedule-appointment/${order?.objectId}`
    navigate(url)
  }

  return (
    <div className={styles.orderInformationContainer}>
      <div className={styles.customerName}>{customerName}</div>
      <div className={styles.installationAppointment}>
        {isDelivery ? 'Scheduled Delivery' : 'Installation Appointment:'}
      </div>
      <div className={styles.orderInformation}>
        {timeSlotInformation}
        <br />
        {!isDelivery && !ARRIVED_STATUSES.includes(order?.status ?? '') ? (
          <div
            className={styles.rescheduleLink}
            onClick={onRescheduleClick}
          >
            Reschedule
          </div>
        ) : (
          <></>
        )}
        {vehicleYearAndMake}
        <br />
        {vehicleModelAndVariant}
        <br />
        {order?.location?.standbyQueueActive && !isDelivery && (
          <PrimaryCheckbox
            style={{ height: '30px', width: '30px', marginRight: '5px' }}
            checked={isStandbyQueueChecked}
            onChange={standbyQueueHandler}
            label='Notify me about earlier appointments'
            disabled={disableStandbyQueueOption}
          />
        )}
      </div>
    </div>
  )
}
